import React from 'react';

const ModalityFormModal = ({
  isDialogOpen,
  editingModality,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
}) => {
  if (!isDialogOpen) return null;

  const title = editingModality ? 'Editar Modalidad' : 'Crear Nueva Modalidad';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';

  return (
    <div className="fixed text-white inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-primary-dark max-w-lg rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">

          <div className="grid grid-cols-2 gap-4">

            {/* Nombre */}
            <div>
              <label className="block text-sm font-medium">Nombre</label>
              <input type="text" name="name" value={formData.name} onChange={handleFieldChange} className={inputClass} required />
            </div>

            {/* Código DICOM */}
            <div>
              <label className="block text-sm font-medium">Código DICOM (Ej. CT, MR)</label>
              <input type="text" name="dicom_code" value={formData.dicom_code} onChange={handleFieldChange} className={inputClass} required disabled={!!editingModality} />
            </div>

            {/* Descripción */}
            <div className="col-span-2">
              <label className="block text-sm font-medium">Descripción</label>
              <textarea name="description" value={formData.description || ''} onChange={handleFieldChange} className={inputClass} rows={2} />
            </div>

            {/* Estado */}
            <div className="col-span-2 flex items-center gap-6 pt-2">
              <label className="flex items-center space-x-2 text-sm">
                <input type="checkbox" name="status" checked={formData.status} onChange={handleFieldChange} />
                <span>Activa/Inactiva</span>
              </label>
            </div>

          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button type="button" onClick={resetForm} className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500">Cancelar</button>
            <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900">
              {editingModality ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalityFormModal;
